import { useTranslation } from '@gem/modules/i18n';
import dateService from '@gem/services/date-service';

import { FinishReasons } from 'APP/model/mainCall/mainCallModel.types';
import Entities from 'STORE';

export function useCallPayloadPresenter(payload) {
  const { t } = useTranslation();
  const isMeInitiator = Entities.usersStore.Me.id === payload.initiatorId;
  const isIncoming = Entities.usersStore.Me.id !== payload.startInitiatorId;
  let duration = dateService.getDurationText(payload.duration);

  const initiator = isMeInitiator
    ? t('chat_details_myself')
    : Entities.usersStore.getUserById(payload.initiatorId)?.displayName ||
      payload.initiatorNickName;

  if (payload.isP2P) {
    if (payload.isFinishCall) {
      switch (payload.reason) {
        case FinishReasons.Declined: {
          return t('p2p_call_declined');
        }
        case FinishReasons.Unanswered: {
          return isIncoming ? t('p2p_missed_call') : t('p2p_call_no_answer');
        }
        default: {
          if (payload.initiatorId) {
            return t('p2p_call_finished').replace('{0}', initiator) + duration;
          }
          return t('group_call_finished');
        }
      }
    }
    return isIncoming ? t('p2p_incoming_call') : t('p2p_outgoing_call');
  }

  if (isMeInitiator) {
    if (payload.isFinishCall) {
      return (
        t('group_call_finished_for_initiator').replace('{0}', t('chat_details_myself')) + duration
      );
    }
    return t('group_call_started_for_initiator').replace('{0}', t('chat_details_myself'));
  }

  if (payload.isFinishCall) {
    if (payload.initiatorId) {
      return t('group_call_finished_for_receiver').replace('{0}', initiator) + duration;
    }
    return t('group_call_finished') + duration;
  }
  return t('group_call_started_for_receiver').replace('{0}', initiator);
}
